import { FormattedMessage, useIntl } from "react-intl";
import { useState } from "react";
import { Select, Value } from "baseui/select";
import { FormControl } from "baseui/form-control";
import { CounterMedium } from "../../../Devices/CounterMedium";
import { useSetObjectValue } from "../../../../hooks/useSetObjectValue";
import { IPortfolioEnergyChart, TimeRange } from "./types";


const ConfigurationPanel = (props: IPortfolioEnergyChart) => {

    return (
        <>
            <CounterMediumSelect {...props}></CounterMediumSelect>
            <RangeSelect {...props}></RangeSelect>
        </>
    )

}

export default ConfigurationPanel

const CounterMediumSelect = (props: IPortfolioEnergyChart) => {
    // counter type
    const [value, setValue] = useSetObjectValue(props.id, props.resourceGroupId, "counterMediumFilter", props.counterMediumFilter,10);
    const [selected, setSelected] = useState<Value>([{ id: value, label: <FormattedMessage id={`CounterMedium.${CounterMedium[value]}`} defaultMessage={`${CounterMedium[value]}`} /> }]);
    const handleChanged = (e: any) => {
        setSelected(e.value);
        setValue(e.value[0].id);
    }
    const types = Object.keys(CounterMedium).filter((item) => {
        return isNaN(Number(item));
    });
    const options = types.map((item: any, index: number) => { return { label: <FormattedMessage id={`CounterMedium.${item}`} defaultMessage={`${item}`} />, id: index } });

    return (
        <FormControl
            label={<FormattedMessage id="Devices.CounterMedium" defaultMessage="Medium" />}
            caption={<FormattedMessage id="Devices.TextCounterMedium" defaultMessage="Select the medium to display" />}
        >
            <Select
                options={options}
                value={selected}
                required
                multi={false}
                searchable={false}
                clearable={false}
                labelKey="label"
                valueKey="id"
                onChange={handleChanged}
            />

        </FormControl>
    )
}

const RangeSelect = (props: IPortfolioEnergyChart) => {
    // counter type
    const [value, setValue] = useSetObjectValue(props.id, props.resourceGroupId, "timeRange", props.timeRange,10);
    const [selected, setSelected] = useState<Value>([{ id: value, label: <FormattedMessage id={`${TimeRange[value]}`} defaultMessage={`${TimeRange[value]}`} /> }]);
    const handleChanged = (e: any) => {
        setSelected(e.value);
        setValue(e.value[0].id);
    }
    const types = Object.keys(TimeRange).filter((item) => {
        return isNaN(Number(item));
    });
    const options = types.map((item: any, index: number) => { return { label: <FormattedMessage id={`${item}`} defaultMessage={`${item}`} />, id: index } });

    return (
        <FormControl
            label={<FormattedMessage id="timeRangeInput" defaultMessage="TimeRange" />}
            caption={<FormattedMessage id="timeRangeInputDescription" defaultMessage="Select a time range" />}
        >
            <Select
                options={options}
                value={selected}
                required
                multi={false}
                searchable={false}
                clearable={false}
                labelKey="label"
                valueKey="id"
                onChange={handleChanged}
            />

        </FormControl>
    )
}